import React, { useEffect } from 'react';
import './campos-componente-contato.component.scss';
import { Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import { ItensMenuModel } from '../../models/menu.model';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import SessaoModel from '../../models/sessao.model';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { CONSTANTS } from '../../constants/constants';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import { ComponentsModel } from '../../models/layout.model';
import IDsMenuSelectComponent from '../ids-menu-select/ids-menu-select.component';
import Editor from 'react-simple-wysiwyg';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type CamposComponenteContatoComponentProps = {
  setVal: (val: ComponentsModel) => void;
  removeItem: (id?: string) => void;
  componente?: ComponentsModel;
  menu: ItensMenuModel[];
}

function CamposComponenteContatoComponent(props: CamposComponenteContatoComponentProps) {

  const [idInput, setIdInput] = React.useState(props.componente?.contato ? props.componente.contato.id : '');
  const [tituloInput, setTituloInput] = React.useState(props.componente?.contato ? props.componente.contato?.titulo : '');
  const [descricaoInput, setDescricaoInput] = React.useState(props.componente?.contato ? props.componente.contato?.descricao : '');
  const [enderecoInput, setEnderecoInput] = React.useState(props.componente?.contato ? props.componente.contato?.endereco : '');
  const [iframeInput, setIframeInput] = React.useState(props.componente?.contato ? props.componente.contato?.iframe.replace(/\\/g, '') : '');
  const [bgInput, setBgInput] = React.useState(props.componente?.contato ? props.componente.contato?.bg : '');
  const [corDoTituloInput, setCorDoTituloInput] = React.useState(props.componente?.contato ? props.componente.contato?.cor_do_titulo : '');
  const [corDoTextoInput, setCorDoTextoInput] = React.useState(props.componente?.contato ? props.componente.contato?.cor_do_texto : '');
  const [corDoCampoInput, setCorDoCampoInput] = React.useState(props.componente?.contato ? props.componente.contato?.cor_do_campo : '');
  const [corEfeitoDoCampoInput, setCorEfeitoDoCampoInput] = React.useState(props.componente?.contato ? props.componente.contato?.cor_efeito_do_campo : '');
  const [corTextoBotaoInput, setCorTextoBotaoInput] = React.useState(props.componente?.contato ? props.componente.contato?.cor_texto_do_botao : '');
  const [corBgBotaoInput, setCorBgBotaoInput] = React.useState(props.componente?.contato ? props.componente.contato?.cor_fundo_do_botao : '');
  const [emailParaEnvioDoFormularioInput, setEmailParaEnvioDoFormularioInput] = React.useState(props.componente?.contato ? props.componente.contato?.email_para_envio_do_formulario : '');

  const [valueTab, setValueTab] = React.useState(0);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      id: props.componente?.id,
      tipo: CONSTANTS.TIPO_COMPONENTE.CONTATO,
      contato: {
        id: idInput,
        titulo: tituloInput,
        descricao: descricaoInput.replace(/"/g, '\\"'),
        endereco: enderecoInput,
        iframe: iframeInput.replace(/"/g, '\\"'),
        bg: bgInput,
        cor_do_titulo: corDoTituloInput,
        cor_do_texto: corDoTextoInput,
        cor_do_campo: corDoCampoInput,
        cor_efeito_do_campo: corEfeitoDoCampoInput,
        cor_texto_do_botao: corTextoBotaoInput,
        cor_fundo_do_botao: corBgBotaoInput,
        email_para_envio_do_formulario: emailParaEnvioDoFormularioInput
      }
    });
  };

  return (
    <section className="campos-componente-contato">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTab}
            onChange={(event: React.SyntheticEvent, newValue: number) => setValueTab(newValue)}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
            <Tab label="Estilo" {...a11yProps(1)} />
            <Tab label="Opções" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <h2>Geral</h2>
          {
            (props.menu.length && props.componente) &&
            <div className="campo w100">
              <IDsMenuSelectComponent val={props.componente?.contato?.id} menus={props.menu} setVal={(val) => setIdInput(val)} />
            </div>
          }
          <div className="campo w100">
            <TextField value={tituloInput} onChange={(event) => setTituloInput(event.target.value)} label="Título" />
          </div>
          <div className="campo w100">
            <TextField value={enderecoInput} onChange={(event) => setEnderecoInput(event.target.value)} label="Endereço" />
          </div>
          <div className="campo w100">
            <TextField rows={3} multiline value={iframeInput} onChange={(event) => setIframeInput(event.target.value)} label="Iframe" />
          </div>
          <div className="campo w100">
            <strong>Descrição</strong>
            <Editor value={descricaoInput} onChange={(e) => setDescricaoInput(e.target.value)} />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <h2>Estilo contato</h2>
          <label className='w50'>
            <span>Cor de fundo:</span>
            <input type='color' value={bgInput} onChange={(val) => setBgInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do título:</span>
            <input type='color' value={corDoTituloInput} onChange={(val) => setCorDoTituloInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto:</span>
            <input type='color' value={corDoTextoInput} onChange={(val) => setCorDoTextoInput(val.currentTarget.value)} />
          </label>


          <label className='w50'>
            <span>Cor do campo:</span>
            <input type='color' value={corDoCampoInput} onChange={(val) => setCorDoCampoInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor efeito do campo:</span>
            <input type='color' value={corEfeitoDoCampoInput} onChange={(val) => setCorEfeitoDoCampoInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor fundo do botão:</span>
            <input type='color' value={corBgBotaoInput} onChange={(val) => setCorBgBotaoInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor texto do botão:</span>
            <input type='color' value={corTextoBotaoInput} onChange={(val) => setCorTextoBotaoInput(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <h2>Opções contato</h2>
          <div className="campo w100">
            <TextField value={emailParaEnvioDoFormularioInput} onChange={(event) => setEmailParaEnvioDoFormularioInput(event.target.value)} label="E-mail para envio do formulário" />
          </div>
        </CustomTabPanel>
      </Box>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.componente?.id)}><DeleteIcon /> Remover contato</Button>
      </div>
    </section>
  );
}

export default CamposComponenteContatoComponent;
